var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({ padding: '15px 0'})},[_c('WingBlank',[_c('PlaceHolder')],1),_vm._v(" "),_c('WhiteSpace',{attrs:{"size":"lg"}}),_vm._v(" "),_c('WingBlank',{attrs:{"size":"md"}},[_c('PlaceHolder')],1),_vm._v(" "),_c('WhiteSpace',{attrs:{"size":"lg"}}),_vm._v(" "),_c('WingBlank',{attrs:{"size":"sm"}},[_c('PlaceHolder')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33066322","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/WingBlank.vue
// module id = null
// module chunks = 